module.exports = __webpack_public_path__ + "static/media/Helen-Morris.b96b97cc.jpg";